export enum OnyxMessageType {
  NEUTRAL = 'neutral',
  INFORMATION = 'information',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}
